<template>
  <div class="backpack-page">
    <!-- 背包 -->
    <div class="backpack-content-wrap" style="position: relative; width: 100%">
      <div class="top-box flex-box">
        <div
          id="filter-box"
          class="filter-box fl"
          @click="showSortBox"
          style="margin-right: 10px"
        >
          <span class="van-popover__wrapper">
            <el-dropdown
              trigger="click"
              class="filter-btn"
              @command="handlesort"
            >
              <span class="el-dropdown-link">
                <div class="text">{{ selected }}</div>
                <div class="right-icon">
                  <img
                    src="../../../assets/images/bottom-icon.png"
                    alt=""
                    class="arrow-icon"
                  />
                </div>
              </span>
              <el-dropdown-menu slot="dropdown" class="sort-list">
                <el-dropdown-item command="0">默认排序</el-dropdown-item>
                <el-dropdown-item command="1">价格从低到高</el-dropdown-item>
                <el-dropdown-item command="2">价格从高到低</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </span>
        </div>
        <!-- <div class="extracted" @click="doExtracted">
          <div class="check-all-icon">
            <img
              v-if="extracted"
              src="../../../assets/images/right-icon.png"
              alt=""
              class="img"
              mode="aspectFit"
            />
          </div>
          可提取
        </div> -->
        <div
          class="take-back-btn fr"
          @click="openCurrency"
          style="font-size: 28rpx"
        >
          货币转换
        </div>
        <div
          class="take-back-btnbj fr"
          @click="openConfirmDelivery"
          style="font-size: 28rpx"
        >
          提货
        </div>
      </div>
      <div class="prod-list-content">
        <div role="feed" class="van-list" @scroll="scrollEventFn" :class="{'grid-one': arr.length == 0}">
          <div
            class="prod-itemx"
            :class="item.isselect ? 'isselect' : ''"
            @click="handleSelect(item)"
            v-for="(item, index) in arr"
            :key="index"
          >
            <div class="sel-mask" v-if="item.isselect"></div>
            <div class="jinbi">
              <img
                src="@/assets/home/jifen.png"
                style="width: 10px; height: 10px"
                alt=""
              />
              <span>{{ item.ornamentsPrice }}</span>
            </div>
            <div class="img">
              <img
                :src="$getFullPath(item.imageUrl)"
                alt=""
                style="height: 100%; width: 100%"
                mode="aspectFit"
              />
            </div>
            <div class="prod-info">
              <p class="prod-name text-ellipsis">
                {{ item.shortName || item.name }}
              </p>
              <p class="wear">{{ item.exteriorName }}</p>
            </div>
          </div>
         
          <div v-if="arr.length == 0" style="width: 100%;position: relative">
            <div class="no-data">
              <div class="empty-box-new"></div>
              <div class="tip-text">暂无数据</div>
            </div>
          </div>
        </div>
      </div>
      <div class="bottom-box">
        <div class="left">
          <div class="search-box">
            <span> 全选 </span>
            <div
              :class="['check-all-icon', isAll ? 'isAll' : '']"
              @click="handleSelectAll"
            >
            
            </div>
          </div>
          <div class="guzhi">
            <div class="guzhi-left">
              <span class="num-1">{{ totalOrnamentNumber }}</span>
              <span class="num-1 num-line">/</span>
              <span class="num-3">{{ recyleMoney.index }}件</span>
            </div>
            <div class="guzhi-right">
              <span class="label">估值</span>
              <span class="total-price">{{ recyleMoney.money }}</span>
            </div>
          </div>
        </div>
        <div class="right" @click="openConfirm">
          <span>回收</span>
        </div>
      </div>
      <!-- <div class="bb-bottom-total flex-box">
        <div class="left-total-info">
          <div class="top flex-box">
            <div class="label">全选</div>
            <div class="check-all-icon" @click="handleSelectAll">
              <img v-if="isAll" src="../../../assets/images/right-icon.png" alt="" class="img" mode="aspectFit" />
            </div>
            <div class="num-total">
              <span class="num-1">{{ totalOrnamentNumber }}</span>
              <span class="num-line">/</span>
              <span class="num-3">{{ recyleMoney.index }}件</span>
            </div>
          </div>
          <div class="total-info flex-box">
            <span class="label">估值</span>
            <span class="total-price">{{ recyleMoney.money }}</span>
          </div>
        </div>
        <div class="buy-back-btn" @click="openConfirm"><span>回收</span></div>
      </div> -->
    </div>
    <!-- 回收弹窗 -->
    <modalRecycle
      :showModal="Confirm"
      :amount="recyleMoney.money"
      @close="cancelConfirm"
      @confirm="handledecompose"
      modalText="回收道具"
    >
      <template #buyBox>
        <div class="buy-box">
          <span style="color: #fff; font-size: 16px; margin-right: 8px"
            >将道具转换为</span
          >
          <img
            class="default-currency"
            src="@/assets/home/jifen.png"
            mode="aspectFit"
            alt=""
          />
          <span class="price" style="color: #c6daff; font-size: 16px">{{
            recyleMoney.money
          }}</span>
        </div>
      </template>
    </modalRecycle>
    <!-- 提货弹窗 -->
    <modalRecycle
      :showModal="confirmDelivery"
      @close="cancelConfirm"
      @confirm="handledelivery"
      modalText="提取饰品"
    >
      <template #buyBox>
        <div class="buy-box">
          <span style="color: #fff; font-size: 16px"
            >确定要提取{{ selectarr.length }}件物品吗？</span
          >
        </div>
      </template>
    </modalRecycle>
    <!-- 积分转化 -->
    <modalCurrency
      :showModal="showCurrency"
      @close="showCurrency = false"
      @confirm="handleCurrency"
    >
    </modalCurrency>
  </div>
</template>

<script>
import {
  getPackSack,
  decompose,
  delivery,
  getUserInfo,
  packSackGlobalData,
  userCreditsToAmount,
} from "@/api/index";
import modalRecycle from "@/components/common/modalRecycle.vue";
import modalCurrency from "@/components/common/modalCurrency.vue";
export default {
  components: { modalRecycle, modalCurrency },
  data() {
    return {
      onsubmit: true,
      Confirm: false,
      confirmDelivery: false,
      isok: false,
      isselectall: false,
      number: 20,
      selectlist: false,
      searchTerm: "",
      selected: "默认排序",
      arr: [],
      isAll: false,
      selectarr: [],
      page: {
        page: 1,
        size: 20,
        orderByFie: 1,
        orderByType: 2,
        name: "",
      },
      isOver: "加载中",
      totalOrnamentNumber: 0,
      totalOrnamentPrice: 0,
      // --------------
      safe_top: 80,
      lists: [],
      sortIndex: 0,
      extracted: false,
      showCurrency: false,
    };
  },
  computed: {
    recyleMoney() {
      let money = 0;
      let index = 0;
      this.arr.forEach((item) => {
        if (item.isselect == true) {
          money += item.ornamentsPrice * 1;
          index++;
        }
      });
      return { money: money.toFixed(2), index };
    },
  },
  mounted() {
    this.getlist();
  },

  methods: {
    doExtracted() {
      this.extracted = !this.extracted;
    },
    doSelectAll() {},
    showSortBox() {},
    // 提货
    openOffer() {},
    getLists() {},
    // ---------------
    playAudio() {
      this.$store.commit("playAudio");
    },
    handleCurrency(item) {
      userCreditsToAmount({ credits: item }).then((res) => {
        if (res.code == 200) {
          this.$message({
            duration: 1000,
            message: "兑换成功",
            type: "success",
            customClass: "log_success",
          });
          this.getlist();
          this.showCurrency = false;
        }
      });
    },
    // 触底加载
    scrollEventFn(event) {
      const container = event.target;
      if (
        container.scrollTop + container.clientHeight + 1 >=
        container.scrollHeight
      ) {
        if (this.isOver == "加载中") {
          this.page.page++;
          setTimeout(() => {
            this.getlist();
          }, 5);
        }
      }
    },
    // 弹出确认框
    openConfirm() {
      if (this.selectarr.length == 0) {
        this.$soundPlay("opFail");
        this.$message({
          duration: 1000,
          message: "请先选择饰品再操作",
          type: "warning",
          customClass: "log_warning",
        });
        return;
      } else {
        this.Confirm = true;
        this.$soundPlay("dialogOpen");
      }
    },
    openConfirmDelivery() {
      if (this.selectarr.length == 0) {
        this.$soundPlay("opFail");
        this.$message({
          duration: 1000,
          message: "请先选择饰品再操作",
          type: "warning",
          customClass: "log_warning",
        });
        return;
      } else {
        this.confirmDelivery = true;
      }
    },
    openCurrency() {
      this.showCurrency = true;
    },
    handledelivery() {
      if (this.selectarr.length == 0) {
        this.$soundPlay("opFail");
        this.$message({
          duration: 1000,
          message: "请先选择饰品再操作",
          type: "warning",
          customClass: "log_warning",
        });
        return;
      } else {
        const selectedItems = this.arr.filter((item) => item.isselect === true);
        this.selectarr = selectedItems.map((item) => item.id);
        delivery({ isAll: this.isAll, packSackIds: this.selectarr }).then(
          (res) => {
            if (res.data.code == 200) {
              if (this.isAll) {
                this.isAll = false;
              }
              this.$message({
                duration: 1000,
                message: res.data.msg,
                type: "success",
                customClass: "log_success",
              });
              // this.getlist();
              this.confirmDelivery = false;
              this.arr = this.arr.filter((item) => {
                return !this.selectarr.includes(item.id);
              });
              this.getGlobalData();
            } else {
              this.$soundPlay("opFail");
              this.$message({
                duration: 1000,
                message: res.data.msg,
                type: "warning",
                customClass: "log_warning",
              });
            }
          }
        );
      }
    },
    cancelConfirm() {
      this.Confirm = false;
      this.confirmDelivery = false;
    },
    handleSelectAll() {
      if (this.isAll == true) {
        // 取消全选
        for (let i = 0; i < this.arr.length; i++) {
          this.arr[i].isselect = false;
        }
        const selectedItems = this.arr.filter((item) => item.isselect === true);
        this.selectarr = selectedItems.map((item) => item.id);

        // if (this.selectarr.length == this.arr.length) {
        this.isAll = false;
        // }
      } else if (this.isAll == false) {
        // 全选
        for (let i = 0; i < this.arr.length; i++) {
          this.arr[i].isselect = true;
        }
        const selectedItems = this.arr.filter((item) => item.isselect === true);
        this.selectarr = selectedItems.map((item) => item.id);

        if (this.selectarr.length == this.arr.length) {
          this.isAll = true;
        }
      }
    },
    handlesort(res) {
      this.page.page = 1;
      this.arr = [];
      if (res == 1) {
        this.selected = "价格从低到高";
        this.page.orderByFie = 2;
        this.page.orderByType = 1;
        this.getlist();
        // this.arr.sort((a, b) => a.ornamentsPrice - b.ornamentsPrice);
      } else if (res == 2) {
        this.selected = "价格从高到低";
        this.page.orderByFie = 2;
        this.page.orderByType = 2;
        this.getlist();
        // this.arr.sort((a, b) => b.ornamentsPrice - a.ornamentsPrice);
      } else if (res == 0) {
        this.selected = "默认排序";
        this.page.orderByFie = 1;
        this.page.orderByType = 2;
        this.getlist();
      }
      this.selectlist = false;
    },
    handlesearch() {
      this.page.page = 1;
      this.arr = [];
      this.page.orderByFie = 1;
      this.page.orderByType = 2;
      this.getlist();
      // if (this.searchTerm == "") {
      //   this.getlist();
      // } else {
      //   let aa = this.arr.filter((item) => {
      //     return item.itemName.includes(this.searchTerm);
      //   });
      //   this.arr = aa;
      // }
    },
    handleSelect(res) {
      this.$soundPlay("boxSelect");
      res.isselect = !res.isselect;
      const selectedItems = this.arr.filter((item) => item.isselect === true);
      this.selectarr = selectedItems.map((item) => item.id);
      if (this.selectarr.length == this.totalOrnamentNumber) {
        this.isAll = true;
      } else {
        this.isAll = false;
      }
    },
    handledecompose() {
      const selectedItems = this.arr.filter((item) => item.isselect === true);
      this.selectarr = selectedItems.map((item) => item.id);

      decompose({ isAll: this.isAll, packSackIds: this.selectarr }).then(
        (res) => {
          if (res.data.code === 200) {
            if (this.isAll) {
              this.isAll = false;
            }
            setTimeout(() => {
              this.Confirm = false;
              this.$message({
                duration: 1000,
                message: "分解成功",
                type: "success",
                customClass: "log_success",
              });
              getUserInfo().then((res) => {
                this.user = res.data.data;
                this.$store.commit("USER_INFO", res.data.data);
              });
              this.onsubmit = true;
            }, 400);

            this.arr = this.arr.filter((item) => {
              return !this.selectarr.includes(item.id);
            });
            this.getGlobalData();
          } else {
            this.$soundPlay("opFail");
            this.Confirm = false;
          }
        }
      );
    },
    getGlobalData() {
      packSackGlobalData().then((res) => {
        // console.log("背包统计", res.data);
        this.totalOrnamentPrice = res.data.data.totalOrnamentPrice;
        this.totalOrnamentNumber = res.data.data.totalOrnamentNumber;
      });
    },
    getlist() {
      this.getGlobalData();
      getPackSack(this.page).then((res) => {
        let arr = [];
        arr = res.data.data;
        if (this.isAll == true) {
          arr = arr.map((item) => ({ ...item, isselect: true }));
        } else {
          arr = arr.map((item) => ({ ...item, isselect: false }));
        }
        this.arr.push(...arr);
        console.log("获取背包数据", this.arr);
        this.isok = true;
        if (res.data.data.length < this.page.size) {
          this.isOver = "暂无更多";
        }
      });
    },
  },
  watch: {
    Confirm(newValue) {
      if (newValue) {
        this.$soundPlay("dialogOpen");
      } else {
        this.$soundPlay("dialogClose");
      }
    },
    confirmDelivery(newValue) {
      if (newValue) {
        this.$soundPlay("dialogOpen");
      } else {
        this.$soundPlay("dialogClose");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
// 新的代码
.backpack-page {
  height: calc(100vh - 160px) !important;
}

.backpack-page .backpack-content-wrap {
  width: 100 * 4.2px;
  height: 100%;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
}

.backpack-page .backpack-content-wrap .top-box {
  width: 100%;
  height: 13.87 * 4.2px;
  float: left;
  padding-top: 1.6 * 4.2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  justify-content: space-between;

  @media only screen and (max-width: 430px) {
    height: 9.87vw;
    padding-top: 3vw;
    margin-bottom: 4vw;
  }
}

.backpack-page .backpack-content-wrap .top-box .take-back-btn {
  width: 26 * 4.2px;
  height: 8.13 * 4.2px;
  line-height: 8.13 * 4.2px;
  background: url("../../../assets/knapsack/2.png") no-repeat 0 0;
  // background: url("../../../assets/images/take_back_btn.png") no-repeat 0 0;
  background-size: 26 * 4.2px 8.13 * 4.2px;
  text-align: center;
  margin-right: 2.93 * 4.2px;

  @media only screen and (max-width: 430px) {
    width: 26vw;
    height: 8.5vw;
    line-height: 8.5vw;
    margin-right: 2.93vw;
    background-size: 26vw 8.5vw;
  }
}

.take-back-btnbj {
  width: 26 * 4.2px;
  height: 8.13 * 4.2px;
  line-height: 8.13 * 4.2px;
  background: url("../../../assets/knapsack/3.png") no-repeat 0 0;
  background-size: 26 * 4.2px 8.13 * 4.2px;
  text-align: center;
  margin-right: 2.93 * 4.2px;

  @media only screen and (max-width: 430px) {
    width: 26vw;
    height: 8.5vw;
    line-height: 8.5vw;
    margin-right: 2.93vw;
    background-size: 26vw 8.5vw;
  }
}

.backpack-page .backpack-content-wrap .prod-list-content {
  // width: 100%;
  // -webkit-box-flex: 1;
  // -webkit-flex: 1;
  // -ms-flex: 1;
  // flex: 1;
  overflow: hidden;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  // overflow-y: auto;
  padding-top: 2.47 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  position: relative;
  background: url("~@/assets/knapsack/5.png") no-repeat 0 0;
  background-size: 100% 100%;
  margin: 0 3.07vw;

  @media only screen and (max-width: 430px) {
    padding-top: 3vw;
    padding-bottom: 3vw;
    // width: 100vw;
    height: 75vh;
  }

  @media only screen and (max-width: 380px) {
    height: 52vh;
  }
}

.backpack-page .backpack-content-wrap .prod-list-content .prod-list-wrap {
  width: 100%;
  // -webkit-box-flex: 1;
  // -webkit-flex: 1;
  // -ms-flex: 1;
  // flex: 1;
  height: 65vh;

  // overflow-x: hidden;
  // overflow-y: auto;
  @media only screen and (max-width: 430px) {
    width: 100vw;
  }
}

.bottom-box {
  margin: 6 * 4.2px 3 * 4.2px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: rgba(10, 0, 76, 0.36);
  border-radius: 8px 8px 8px 8px;
  padding: 14px;
  height: 62px;

  @media only screen and (max-width: 430px) {
    margin: 6vw 3vw;
    height: 62px;
  }

  .left {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    position: relative;

    .search-box {
      display: flex;
      position: absolute;
      left: 0;
      top: 0px;

      span {
        margin-right: 6px;
        font-size: 16px;
        color: #ffffff;
      }
    }

    .guzhi {
      display: flex;
      align-items: center;
      margin-top: 28px;
      font-size: 12px;
      color: #97a3ff;

      .guzhi-left {
        margin-right: 18px;

        .num-3 {
          color: #ffffff;
        }
      }

      .guzhi-right {
        .total-price {
          margin-left: 8px;
          color: #fff;
        }
      }
    }
  }

  .right {
    width: 42.8 * 4.2px;
    height: 12.93 * 4.2px;
    background: url("~@/assets/knapsack/6.png") no-repeat 0 0;
    background-size: 42.8 * 4.2px 12.93 * 4.2px;
    text-align: center;
    line-height: 12.93 * 4.2px;
    font-size: 5.6 * 4.2px;
    color: #ffffff;
    letter-spacing: 0.53 * 4.2px;

    @media only screen and (max-width: 430px) {
      width: 142px;
      height: 43px;
      background-size: 100% 100%;
      font-size: 5.6vw;
      line-height: 43px;
      letter-spacing: 0.53vw;
    }
  }
}

.backpack-page .backpack-content-wrap .prod-list-content .scroll-list-wrap {
  width: 100%;
  overflow: hidden;
}

.backpack-page .backpack-content-wrap .bb-bottom-total {
  width: 100%;
  height: 19.73 * 4.2px;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  position: relative;

  @media only screen and (max-width: 430px) {
    width: 100vw;
    height: 19.73vw;
  }
}

// .backpack-page .backpack-content-wrap .bb-bottom-total:after {
//   content: "";
//   display: block;
//   width: 100%;
//   height: 5.47 * 4.2px;
//   background: url("../../../assets/images/gradient_bg.png") no-repeat 0 0;
//   background-size: 100% 5.47 * 4.2px;
//   position: absolute;
//   left: 0;
//   top: -4.8 * 4.2px;

//   @media only screen and (max-width: 430px) {
//     width: 100vw;
//     height: 5.47vw;
//     top: -4.8vw;
//     background-size: 100vw 5.47vw;
//   }
// }

.backpack-page .backpack-content-wrap .bb-bottom-total .left-total-info {
  width: 54.67 * 4.2px;
  height: auto;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding-left: 3.07 * 4.2px;
  font-size: 4.4 * 4.2px;

  @media only screen and (max-width: 430px) {
    width: 54.67vw;
    padding-left: 3.07vw;
    font-size: 4.4vw;
  }
}

.backpack-page .backpack-content-wrap .bb-bottom-total .left-total-info .top {
  width: 100%;
  height: auto;
  margin-bottom: 0.67 * 4.2px;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;

  @media only screen and (max-width: 430px) {
    margin-bottom: 0.67vw;
  }
}

.backpack-page
  .backpack-content-wrap
  .bb-bottom-total
  .left-total-info
  .top
  .label {
  margin-right: 2.93 * 4.2px;

  @media only screen and (max-width: 430px) {
    margin-right: 2.93vw;
  }
}

.backpack-page
  .backpack-content-wrap
  .bb-bottom-total
  .left-total-info
  .top
  .check-all-icon {
  width: 5.33 * 4.2px;
  height: 5.33 * 4.2px;
  background: url("../../../assets/images/dot.png") no-repeat 0 0;
  background-size: 5.33 * 4.2px 5.33 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;

  @media only screen and (max-width: 430px) {
    width: 5.33vw;
    height: 5.33vw;
    background-size: 5.33vw 5.33vw;
  }
}

.backpack-page
  .backpack-content-wrap
  .bb-bottom-total
  .left-total-info
  .top
  .check-all-icon
  img {
  width: 3.73 * 4.2px;
  height: 2.27 * 4.2px;

  @media only screen and (max-width: 430px) {
    width: 3.73vw;
    height: 2.27vw;
  }
}

.backpack-page
  .backpack-content-wrap
  .bb-bottom-total
  .left-total-info
  .top
  .num-total {
  font-size: 3.33 * 4.2px;
  margin-left: 4.93 * 4.2px;
  color: #a6bbff;
  margin-top: 0.67 * 4.2px;

  @media only screen and (max-width: 430px) {
    font-size: 3.33vw;
    margin-left: 4.93vw;
    margin-top: 0.67vw;
  }
}

.backpack-page
  .backpack-content-wrap
  .bb-bottom-total
  .left-total-info
  .top
  .num-total
  .num-1 {
  color: #ffffff;
}

.backpack-page
  .backpack-content-wrap
  .bb-bottom-total
  .left-total-info
  .top
  .num-total
  .num-line {
  margin: 0 0.67 * 4.2px;

  @media only screen and (max-width: 430px) {
    margin: 0 0.67vw;
  }
}

.backpack-page
  .backpack-content-wrap
  .bb-bottom-total
  .left-total-info
  .total-info {
  width: 100%;
  color: #8a9ddf;
}

.backpack-page
  .backpack-content-wrap
  .bb-bottom-total
  .left-total-info
  .total-info
  .label {
  margin-right: 2.67 * 4.2px;

  @media only screen and (max-width: 430px) {
    margin-right: 2.67vw;
  }
}

.backpack-page
  .backpack-content-wrap
  .bb-bottom-total
  .left-total-info
  .total-info
  .total-price {
  font-size: 4.4 * 4.2px;
  background-image: -webkit-gradient(
    linear,
    left top,
    left bottom,
    from(#edb375),
    to(#ffffff)
  );
  background-image: -webkit-linear-gradient(top, #edb375, #ffffff);
  background-image: -o-linear-gradient(top, #edb375, #ffffff);
  background-image: linear-gradient(to bottom, #edb375, #ffffff);
  color: transparent;
  background-clip: text;
  -webkit-background-clip: text;

  @media only screen and (max-width: 430px) {
    font-size: 4.4vw;
  }
}

.backpack-page .backpack-content-wrap .bb-bottom-total .buy-back-btn {
  width: 42.8 * 4.2px;
  height: 12.93 * 4.2px;
  background: url("~@/assets/knapsack/6.png") no-repeat 0 0;
  background-size: 42.8 * 4.2px 12.93 * 4.2px;
  text-align: center;
  line-height: 12.93 * 4.2px;
  font-size: 5.6 * 4.2px;
  color: #ffffff;
  letter-spacing: 0.53 * 4.2px;

  @media only screen and (max-width: 430px) {
    width: 42.8vw;
    height: 12.93vw;
    background-size: 42.8vw 12.93vw;
    font-size: 5.6vw;
    line-height: 12.93vw;
    letter-spacing: 0.53vw;
  }
}

.prod-item {
  width: 28.67 * 4.2px;
  height: 28.67 * 4.2px;
  // background: url("../../../assets/images/prod_item.png") no-repeat 0 0;
  background-repeat: no-repeat;
  background-position: 0 0;
  background-size: 28.67 * 4.2px 28.67 * 4.2px;
  float: left;
  margin: 0 2.13 * 4.2px 1.2 * 4.2px 2.13 * 4.2px;
  position: relative;

  @media only screen and (max-width: 430px) {
    width: 28.67vw;
    height: 28.67vw;
    background-size: 28.67vw 28.67vw;
    margin: 0 2.13vw 1.2vw 2.13vw;
  }
}

.prod-itemx.golden {
  background-image: url("../../../assets/images/item_golden2.png");
}

.prod-itemx.blue {
  background-image: url("../../../assets/images/item_blue2.png");
}

.prod-itemx .sel-mask {
  width: 8 * 4.2px;
  height: 8 * 4.2px;
  background: url("~@/assets/knapsack/13.png") no-repeat 0 0;
  background-size: 8 * 4.2px 8 * 4.2px;
  position: absolute;
  right: 0;
  top: 0;

  @media only screen and (max-width: 430px) {
    width: 8vw;
    height: 8vw;
    background-size: 8vw 8vw;
  }
}

.prod-item .doing-box {
  width: 26.67 * 4.2px;
  height: 26.67 * 4.2px;
  background: url("../../../assets/images/k17.png") no-repeat 0 0;
  background-size: 26.67 * 4.2px 26.67 * 4.2px;
  position: absolute;
  left: 50%;
  margin-left: -13.33 * 4.2px;
  top: 50%;
  margin-top: -13.33 * 4.2px;
  z-index: 10;
  font-size: 4.4 * 4.2px;
  color: #c7d4ff;

  @media only screen and (max-width: 430px) {
    width: 26.67vw;
    height: 26.67vw;
    background-size: 26.67vw 26.67vw;
    margin-left: -13.33vw;
    margin-top: -13.33vw;
    font-size: 4.4vw;
  }
}

.prod-item .doing-box .taking-text {
  padding-top: 5.07 * 4.2px;
  text-align: center;

  @media only screen and (max-width: 430px) {
    padding-top: 5.07vw;
  }
}

.prod-item .doing-box .get-time {
  text-align: center;
  font-size: 2.67 * 4.2px;

  @media only screen and (max-width: 430px) {
    font-size: 2.67vw;
  }
}

.prod-item .img {
  width: 22 * 4.2px;
  height: 16.27 * 4.2px;
  margin: 2.93 * 4.2px auto;

  @media only screen and (max-width: 430px) {
    width: 22vw;
    height: 16.27vw;
    margin: 2.93vw auto;
  }
}

.prod-item .img image {
  width: 100%;
  height: 100%;
}

.prod-item .prod-info {
  width: 24 * 4.2px;
  height: 14.6px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  position: absolute;
  left: 2.67 * 4.2px;
  bottom: 48.6px;
  color: #fff;
  font-size: 2.67 * 4.2px;
  text-align: left;

  @media only screen and (max-width: 430px) {
    width: 24vw;
    height: 10.67vw;
    left: 2.67vw;
    bottom: 4vw;
    font-size: 2.67vw;
  }
}

.prod-item .prod-info .wear {
  width: 100%;
  height: 4 * 4.2px;
  line-height: 4 * 4.2px;

  @media only screen and (max-width: 430px) {
    height: 4vw;
    line-height: 4vw;
  }
}

.prod-item .prod-info .prod-name {
  width: 100%;
  height: 5.33 * 4.2px;
  line-height: 4.8 * 4.2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;

  @media only screen and (max-width: 430px) {
    height: 5.33vw;
    line-height: 4.8vw;
  }
}

.prod-item .bottom-price {
  width: 100%;
  height: 14.6px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  position: absolute;
  left: 0;
  bottom: 1.33 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  padding-left: 3.33 * 4.2px;

  @media only screen and (max-width: 430px) {
    height: 3vw;
    bottom: 1.33vw;
    padding-left: 3.33vw;
  }
}

.prod-item .bottom-price .bi {
  width: 3.87 * 4.2px;
  height: 3.6 * 4.2px;
  margin-right: 2.27 * 4.2px;

  @media only screen and (max-width: 430px) {
    width: 3.87vw;
    height: 3.6vw;
    margin-right: 2.27vw;
  }
}

.prod-item .bottom-price span {
  font-size: 3.33 * 4.2px;
  color: #ffffff;
  text-shadow: 1px 1px 0 1px rgba(53, 13, 0, 0.55);

  @media only screen and (max-width: 430px) {
    font-size: 3.33vw;
  }
}

.van-list {
  height: calc(100% - 21.134px);
  overflow-y: scroll;

  padding: 3 * 4.2px;

  @media only screen and (max-width: 430px) {
    height: 65vh;
    width: 94vw;
    padding: 3vw;
  }

  display: grid;
  grid-template-columns: repeat(3, 1fr);
  justify-items: center;

  .prod-itemx {
    position: relative;
    width: 25.4 * 4.2px;
    height: 35.5 * 4.2px;
    background: linear-gradient(180deg, #5b1ce3 0%, #320f7d 100%);
    box-shadow: inset 0px 0px 6px 0px #6ba0cd;
    border-radius: 2px 2px 2px 2px;
    border: 0px solid #b378e0;
    padding: 8px;
    box-sizing: border-box;
    font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
    font-size: 10px;
    color: #e5c7ff;
    // margin-right: 2 * 4.2px;
    margin-bottom: 2 * 4.2px;

    @media only screen and (max-width: 430px) {
      width: 27vw;
      height: 35.5vw;
      // margin-right: 3vw;
      background: linear-gradient(180deg, #5b1ce3 0%, #320f7d 100%);
      box-shadow: inset 0px 0px 6px 0px #6ba0cd;
      border-radius: 2px 2px 2px 2px;
      border: 0px solid #b378e0;
      padding: 8px;
      box-sizing: border-box;
      font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
      font-size: 10px;
      color: #e5c7ff;
      margin-bottom: 3vw;
    }

    // &:nth-child(3n) {
    //   margin-right: 0;
    // }

    .jinbi {
      display: flex;
      align-items: center;
      font-style: normal;
      text-transform: none;
      margin-bottom: 4px;

      span {
        margin-left: 4px;
      }
    }

    .img {
      width: 100%;
      height: auto;
    }

    .prod-info {
      margin-top: 4px;
      text-align: left;

      .prod-name {
        margin-bottom: 2px;
      }
    }
  }

  .isselect {
    background: linear-gradient(180deg, #6f1ce3 0%, #e226ff 100%);
    box-shadow: inset 0px 0px 6px 0px #6ba0cd;
    border-radius: 2px 2px 2px 2px;
    border: 1px solid;
    border-image: linear-gradient(
        180deg,
        rgba(224, 255, 255, 1),
        rgba(224, 255, 255, 0),
        rgba(224, 255, 255, 1)
      )
      1 1;
  }
}

// 筛选
.sort-list {
  background: url("../../../assets/knapsack/4.png") repeat-y;
  // background: url("../../../assets/images/line14.png") repeat-y;
  background-position-x: center;
  background-size: contain;
  border: none !important;
  color: #fff;

  /deep/.el-dropdown-menu__item {
    color: #fff !important;

    &:hover {
      background-color: #3a4f90 !important;
      color: #fff !important;
    }
  }

  /deep/.popper__arrow {
    border-bottom-color: #163490 !important;
  }

  /deep/.popper__arrow::after {
    border-bottom-color: #163490 !important;
  }
}

.extracted {
  display: flex;
  justify-content: center;
  font-size: 4 * 4.2px;

  // align-items: center;
  .check-all-icon {
    margin-right: 2 * 4.2px;
  }
}

.check-all-icon {
  width: 5.33 * 4.2px;
  height: 5.33 * 4.2px;
  background: url("~@/assets/knapsack/14.png") no-repeat 0 0;
  background-size: 5.33 * 4.2px 5.33 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.check-all-icon .img {
  width: 15.666px;
  height: 9.534px;
}

.isAll {
  background: url("~@/assets/knapsack/15.png") no-repeat 0 0 !important;
  background-size: 5.33 * 4.2px 5.33 * 4.2px !important;
}

@media only screen and (max-width: 430px) {
  .extracted {
    font-size: 4vw;

    .check-all-icon {
      margin-right: 2vw;
    }
  }

  .check-all-icon {
    width: 4.33vw;
    height: 4.33vw;
    // background: url("../../../assets/images/dot.png") no-repeat 0 0;
    background: url("~@/assets/knapsack/14.png") no-repeat 0 0;
    background-size: 4.33vw 4.33vw;
  }

  .isAll {
    background: url("~@/assets/knapsack/15.png") no-repeat 0 0 !important;
    background-size: 4.33vw 4.33vw !important;
  }

  .check-all-icon .img {
    width: 3.73vw;
    height: 2.27vw;
  }
}
.no-data {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin-top: 0;
}
.grid-one{
  grid-template-columns: repeat(1, 1fr) !important;
}
</style>
